// extracted by mini-css-extract-plugin
export default {"info-box":"PastHistoryWrite_info-box__SckLp","select-list-box":"PastHistoryWrite_select-list-box__eTvoc"};